import { Component, computed, inject } from '@angular/core';
import { LucideAngularModule, RefreshCw } from 'lucide-angular';
import { AppUpdateService } from '@core/services';

/**
 * Tells a tab left open across a deploy that a newer Aleia is available.
 * Detection and the reload itself live in `AppUpdateService`; this only asks.
 */
@Component({
  selector: 'app-update-notice',
  imports: [LucideAngularModule],
  template: `
    @if (visible()) {
      <div
        role="status"
        class="update-notice fixed right-4 bottom-4 z-[70] flex w-[min(360px,calc(100vw-2rem))] gap-3 rounded-xl border p-4"
        style="background: var(--app-surface); border-color: var(--app-border); box-shadow: var(--shadow-md)"
      >
        <lucide-icon
          [img]="icons.RefreshCw"
          [size]="18"
          color="var(--accent)"
          class="mt-0.5 shrink-0"
        />
        <div class="min-w-0 flex-1">
          <p class="text-[14px] font-semibold" style="color: var(--app-text)">
            Hay una nueva versión de Aleia
          </p>
          <p class="mt-1 text-[13px] leading-snug" style="color: var(--app-text-secondary)">
            Recarga para usarla. Si cambias de página, se actualiza sola.
          </p>
          <div class="mt-3 flex gap-2">
            <button
              type="button"
              class="rounded-lg px-3 py-1.5 text-[13px] font-medium text-white transition-opacity hover:opacity-90"
              style="background: var(--accent)"
              (click)="update.reload()"
            >
              Recargar
            </button>
            <button
              type="button"
              class="rounded-lg px-3 py-1.5 text-[13px] font-medium transition-colors hover:bg-[var(--app-hover)]"
              style="color: var(--app-text-secondary)"
              (click)="update.snooze()"
            >
              Más tarde
            </button>
          </div>
        </div>
      </div>
    }
  `,
  styles: [
    `
      .update-notice {
        animation: update-notice-in 180ms ease-out;
      }
      @keyframes update-notice-in {
        from {
          opacity: 0;
          transform: translateY(6px);
        }
        to {
          opacity: 1;
          transform: none;
        }
      }
      @media (prefers-reduced-motion: reduce) {
        .update-notice {
          animation: none;
        }
      }
    `,
  ],
})
export class UpdateNoticeComponent {
  protected readonly update = inject(AppUpdateService);
  protected readonly icons = { RefreshCw };
  protected readonly visible = computed(
    () => this.update.updateAvailable() && !this.update.snoozed(),
  );
}
